export default __webpack_public_path__ + "assets/images/8498b302f23964b5ac0590737e22a025.jpg";